import React from 'react'

const THE_WIDTH_OF_LITTLE_BITS_OF_DATA_WHILST_VIEWING_INFORMATION_FROM_THE_BOTTOM_SHEET = '300PX'
const STANDARD_INDENT = '10PX'

export default function FieldWrapper({
  children,
  size = THE_WIDTH_OF_LITTLE_BITS_OF_DATA_WHILST_VIEWING_INFORMATION_FROM_THE_BOTTOM_SHEET,
  indent = STANDARD_INDENT,
  ...props
}) {
  return (
    <div style={{ width: size, paddingInlineStart: indent, paddingTop: '10PX' }} {...props}>
      {children}
    </div>
  )
}
